import { IMarker } from '../types/interfaces';
import { DEFAULT_LANGUAGE } from './constants';

export async function requestPermissionGeolocation() {
  return navigator.permissions.query({ name: 'geolocation' }).then((result) => {
    return result;
  });
}

export const textLengthFormated = (text, length) => {
  if(String(text).length > length) {
    const formatedText = String(text).length > length
            ? String(text).slice(0, length).trim()
            : text;
    const last = formatedText.slice(formatedText.length - 1, formatedText.length);
    return last === ',' ? `${String(formatedText).slice(0, formatedText.length-1)}...` : `${formatedText}...`;
  }
  return text;
};

// export const textCapitalizeFormater = (text)=> {
//   return `${text.slice(0,1).toUpperCase()}${text.slice(1).toLowerCase()}`;
// };

async function getCurrentPosition() {
  return new Promise<any>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (SuccessPosition) => {
        resolve(SuccessPosition);
      },
      (errorPosition) => {
        reject(errorPosition);
      },
    );
  });
}

export async function getRequestLocation() {
  await requestPermissionGeolocation();
  let location;
  await getCurrentPosition().then((result) => {
    location = result;
  });
  return location;
}

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

// TODO: funcion temporal, no debería hacer falta
export function formatAgencyId(agencyId) {
  const calculatedAgencyId = agencyId !== null ? agencyId.split(':')[1] : null;
  return calculatedAgencyId;
}


export function formatMarkers(markers, dataOri, updateStops) {
  let intercambiadores: any = [];
  markers = markers?.filter((stop) => {
    if (stop.stopGtfsId.includes('est_90')) {
      if (intercambiadores.find((item) => item.stopCode === stop.stopCode)) {
        intercambiadores = intercambiadores.map((item) => {
          return item.stopCode === stop.stopCode
            ? {
                ...item,
                stops: [
                  ...item.stops,
                  {
                    id: stop.id,
                    transportMode: parseInt(stop.stopTransportMode),
                    dataOrigin: stop.agencyOriginId,
                  },
                ],
              }
            : item;
        });
      } else {
        intercambiadores.push({
          id: stop.id,
          position: { lat: stop.stopLat, lng: stop.stopLon },
          selected: false,
          name: stop.stopName,
          stopCode: stop.stopCode,
          stopUrl: stop.stopUrl,
          description: stop.stopDesc,
          transportMode: 90,
          stops: [
            {
              id: stop.id,
              transportMode: parseInt(stop.stopTransportMode),
              dataOrigin: stop.agencyOriginId,
            },
          ],
        });
      }
      return false;
    } else {
      return true;
    }
  });

  intercambiadores = intercambiadores.map((intercambiador) => {
    return {
      ...intercambiador,
      stops: intercambiador.stops
        .sort(function (itemA, itemB) {
          const order = {
            3: 0, // Metro
            10: 1, // Tranvia
            1: 2, // Bus
            2: 3, // Interbus
            7: 4, // Tren
            90: 5, // Intercambiador
          };
          return order[itemA.transportMode] - order[itemB.transportMode];
        })
        .map((item) => item),
    };
  });

  updateStops([
    ...markers?.map((stop) => {
      const dataOrigin = dataOri.filter(
        (itemDataOrigin) => itemDataOrigin.id === stop.agencyOriginId,
      )[0];

      return {
        id: stop.id,
        position: { lat: stop.stopLat, lng: stop.stopLon },
        selected: false,
        name: stop.stopName,
        stopCode: stop.stopCode,
        stopUrl: stop.stopUrl,
        description: stop.stopDesc,
        dataOrigin: dataOrigin?.id,
        transportMode: parseInt(stop.stopTransportMode),
        stopWheelchairBoarding: stop.stopWheelchairBoarding
      };
    }),
    ...intercambiadores,
  ]);
}

export function filterBounds(
  markers: Array<IMarker>,
  { south, north, west, east },
): Array<IMarker> {
  return markers?.filter(
    (marker) =>
      marker?.position?.lat < north &&
      marker?.position?.lat > south &&
      marker?.position?.lng > west &&
      marker?.position?.lng < east,
  );
}

export function filterByTransportsMode(
  stops: Array<any>,
  idsTransportMode: Array<number>,
): Array<any> {
  return stops.filter((stop) => idsTransportMode.includes(stop.transportMode));
}
interface IParseLocation {
  language: string,
  section: string,
  params: Array<any>,
}
export function parseLocation (location :any): IParseLocation {
  if(!location || !location?.pathname) return { language: DEFAULT_LANGUAGE, section: '', params: [] };
  const array = location?.pathname.split('/');
  const retorno = {
    language: array[1],
    section: array[2],
    params: [...array.slice(3)],
  };
  return retorno;
};

export function currentIncludesPath (current:string, path:string): boolean {
  if (current && current !== '' && path && path !== '') {
    const currentAux = current[current.length - 1] === '/' ? current.substring(0, current.length - 1).toLowerCase() : current.toLowerCase();
    const pathAux = path[path.length - 1] === '/' ? path.substring(0, path.length - 1).toLowerCase() : path.toLowerCase();
    return currentAux.includes(pathAux);
  } else{
    return false;
  }
};

export function getLocalStorageLanguage (): string {
  return localStorage.getItem('userLanguage') || DEFAULT_LANGUAGE;

}

export function scrollTop () {
  window.scroll({
    top: 0,
    left: 100,
    behavior: 'smooth',
  });
}


export function accentsTidy (s) {
  const pattern = /´/g;
  var r = s?.toLowerCase().replaceAll(pattern, '').replaceAll(' ', '_');
  r = r?.replace(new RegExp('\\s', 'g'), '');
  r = r?.replace(new RegExp('[àáâãäå]', 'g'), 'a');
  r = r?.replace(new RegExp('æ', 'g'), 'ae');
  r = r?.replace(new RegExp('ç', 'g'), 'c');
  r = r?.replace(new RegExp('[èéêë]', 'g'), 'e');
  r = r?.replace(new RegExp('[ìíîï]', 'g'), 'i');
  r = r?.replace(new RegExp('ñ', 'g'), 'n');
  r = r?.replace(new RegExp('[òóôõö]', 'g'), 'o');
  r = r?.replace(new RegExp('œ', 'g'), 'oe');
  r = r?.replace(new RegExp('[ùúûü]', 'g'), 'u');
  r = r?.replace(new RegExp('[ýÿ]', 'g'), 'y');
  r = r?.replace(new RegExp('\\W', 'g'), '');
  return r;
};

export function convertFromHex(hex) {
  let hexa = hex?.toString();//force conversion
  let str = '';
  for (let i = 0; i < hexa?.length-1; i += 2)
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  return str;
}

export function convertToHex(str) {
  let hex = '';
  for (let i=0; i < str?.length; i++) {
      hex += '' + str.charCodeAt(i)?.toString(16);
  }
  return hex;
}

export const convertirFecha = (fechaStr: string): Date => {
  if (!fechaStr) return new Date();
  const separator = fechaStr.includes('/') ? '/' : '-';
  const [anio, mes, resto] = fechaStr.split(separator);
  const [dia, hora] = resto ? resto?.split(' '): [null, '00:00:00'];
  return new Date(`${anio}-${mes}-${dia}T${hora}:00`);
};

export function alertsSorter(alerts) {

  let initAlerts:any[] = [];
  if (alerts?.length > 0) {
    initAlerts = [...alerts];
    initAlerts.sort((a, b) => {
      const priorityOrderDiff = a.priority.order - b.priority.order;
      if (priorityOrderDiff !== 0) {
        return priorityOrderDiff;
      }

      // Verificamos si ambos tienen fechas válidas
      const fechaA = a.fechas?.[0]?.horaInicio;
      const fechaB = b.fechas?.[0]?.horaInicio;

      if (fechaA && fechaB) {
        return convertirFecha(fechaB).getTime() - convertirFecha(fechaA).getTime();
      }

      // Si no hay fechas en alguno de los elementos, los consideramos iguales
      return 0;
    });
  }

  return initAlerts;
}

export const inputScrollTop = (id)=> {
  if (window.matchMedia('(max-width: 768px)').matches) {
    document
    .getElementById(id)
    ?.scrollIntoView({ behavior: 'smooth', block:'start', inline: 'nearest' });
  }
};
